import api from './api'

const getSingleLot = (lot_id) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return api().get('/api/lots/' + lot_id, { headers: { Authorization: 'Bearer ' + access_token } })
}

const getAuctionsData = () => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return api().get('/api/auctions', { headers: { Authorization: 'Bearer ' + access_token } })
}

const getBrandModels = (brandName) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    console.log(brandName);
    return api().get(`/api/brands/${brandName}/models`, { headers: { Authorization: 'Bearer ' + access_token } })
}

const getModelsByBrandName = (brand) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return api().get('/api/models?brand=' + brand, { headers: { Authorization: 'Bearer ' + access_token } })
}

const getModelsByBrandId = (brandId) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return api().get(`/api/models/${brandId}`, { headers: { Authorization: 'Bearer ' + access_token } })
}


const getCarBrands = () => {
    return carBrands.slice()
}

const getCarMarkas = () => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return api().get(`/api/brands/`, { headers: { Authorization: 'Bearer ' + access_token } })
}

const getChassisByModelName = (modelName) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return api().get(`/api/chassis/${modelName}`, { headers: { Authorization: 'Bearer ' + access_token } })
}

const getCarBrandLabels = () => {
    return allBrandLabels.slice()
}

const getDefaultQuery = () => {
    return Object.assign({}, defaultQuery)
}

const getMarketPrice = (lotId, query) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return api().get(`/api/stats/${lotId}`, {
        headers: { Authorization: 'Bearer ' + access_token } ,
        params: query
    })
}

const getPastResult = (query) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return api().get(`/api/stats/`, {
        headers: { Authorization: 'Bearer ' + access_token } ,
        params: query
    })
}

const getAllLotPhotos = (lotId) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return api().get(`/api/images/${lotId}`, {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}

export default {
    getSingleLot,
    getCarBrands,
    getCarBrandLabels,
    getBrandModels,
    getAuctionsData,
    getMarketPrice,
    getModelsByBrandName,
    getPastResult,
    getCarMarkas,
    getModelsByBrandId,
    getChassisByModelName,
    getAllLotPhotos
}

const defaultQuery = {
    brand: '',
    'models': [],
    'grades': [],
    yearMin: 1970,
    yearMax: new Date().getFullYear(),
    kmsMin: 1,
    kmsMax: 300,
    priceMin: 0,
    priceMax: 300,
    ccMin: 1,
    ccMax: 6000,
    carGrade: null,
    'chassis': [],
    'transmissions': [],
    'lots': [],
    'colors': [],
    'equipment': [],
    'auctions': [],
    page: 1
}

const allBrandLabels = [
    {
        brandName: 'Japanese brand',
        country: 'Japan'
    },
    {
        brandName: 'German brands',
        country: 'Germany'
    },
    {
        brandName: 'British brands',
        country: 'Great Britain'
    },
    {
        brandName: 'French brands',
        country: 'France'
    },
    {
        brandName: 'Italian brands',
        country: 'Italy'
    },
    {
        brandName: 'Swedish brands',
        country: 'Sweden'
    },
    {
        brandName: 'Korean brands',
        country: 'Korea'
    },
    {
        brandName: 'American brands',
        country: 'USA'
    }
]

const carBrands = [
    {
        "id": 1,
        "label": "TOYOTA",
        "country": "Japan",
        "top": true
    },
    {
        "id": 2,
        "label": "NISSAN",
        "country": "Japan",
        "top": true
    },
    {
        "id": 5,
        "label": "HONDA",
        "country": "Japan",
        "top": true
    },
    {
        "id": 3,
        "label": "MAZDA",
        "country": "Japan",
        "top": true
    },
    {
        "id": 4,
        "label": "MITSUBISHI",
        "country": "Japan",
        "top": true
    },
    {
        "id": 100,
        "label": "EUNOS",
        "country": "Japan",
        "top": false
    },
    {
        "id": 101,
        "label": "FORD JAPAN",
        "country": "Japan",
        "top": false
    },
    {
        "id": 7,
        "label": "SUBARU",
        "country": "Japan",
        "top": true
    },
    {
        "id": 9,
        "label": "DAIHATSU",
        "country": "Japan",
        "top": true
    },
    {
        "id": 6,
        "label": "SUZUKI",
        "country": "Japan",
        "top": true
    },
    {
        "id": 10,
        "label": "MITSUOKA",
        "country": "Japan",
        "top": false
    },
    {
        "id": 8,
        "label": "ISUZU",
        "country": "Japan",
        "top": false
    },
    {
        "id": 121,
        "label": "CHEVROLET",
        "country": "USA",
        "top": true
    },
    {
        "id": 19,
        "label": "FORD",
        "country": "USA",
        "top": false
    },
    {
        "id": 151,
        "label": "SATURN",
        "country": "USA",
        "top": false
    },
    {
        "id": 119,
        "label": "CADILLAC",
        "country": "USA",
        "top": false
    },
    {
        "id": 154,
        "label": "STARCRAFT",
        "country": "USA",
        "top": false
    },
    {
        "id": 35,
        "label": "LINCOLN",
        "country": "USA",
        "top": false
    },
    {
        "id": 15,
        "label": "CHRYSLER",
        "country": "USA",
        "top": false
    },
    {
        "id": 122,
        "label": "JEEP",
        "country": "USA",
        "top": false
    },
    {
        "id": 125,
        "label": "EUROPE FORD",
        "country": "Germany",
        "top": false
    },
    {
        "id": 28,
        "label": "ROVER",
        "country": "Great Britain",
        "top": false
    },
    {
        "id": 336,
        "label": "TIARA",
        "country": "USA",
        "top": false
    },
    {
        "id": 33,
        "label": "MG",
        "country": "Great Britain",
        "top": false
    },
    {
        "id": 34,
        "label": "LAND ROVER",
        "country": "Great Britain",
        "top": false
    },
    {
        "id": 132,
        "label": "JAGUAR",
        "country": "Great Britain",
        "top": false
    },
    {
        "id": 149,
        "label": "ROLLSROYCE",
        "country": "Great Britain",
        "top": false
    },
    {
        "id": 112,
        "label": "ASTON MARTIN",
        "country": "Great Britain",
        "top": false
    },
    {
        "id": 115,
        "label": "BENTLEY",
        "country": "Great Britain",
        "top": false
    },
    {
        "id": 13,
        "label": "AUDI",
        "country": "Germany",
        "top": true
    },
    {
        "id": 155,
        "label": "TVR",
        "country": "Great Britain",
        "top": false
    },
    {
        "id": 14,
        "label": "BMW",
        "country": "Germany",
        "top": true
    },
    {
        "id": 24,
        "label": "MERCEDES BENZ",
        "country": "Germany",
        "top": true
    },
    {
        "id": 117,
        "label": "BMW ALPINA",
        "country": "Germany",
        "top": false
    },
    {
        "id": 111,
        "label": "AMG",
        "country": "Germany",
        "top": false
    },
    {
        "id": 25,
        "label": "OPEL",
        "country": "Germany",
        "top": false
    },
    {
        "id": 148,
        "label": "PORSCHE",
        "country": "Germany",
        "top": true
    },
    {
        "id": 31,
        "label": "VOLKSWAGEN",
        "country": "Germany",
        "top": true
    },
    {
        "id": 16,
        "label": "CITROEN",
        "country": "France",
        "top": false
    },
    {
        "id": 26,
        "label": "PEUGEOT",
        "country": "France",
        "top": true
    },
    {
        "id": 27,
        "label": "RENAULT",
        "country": "France",
        "top": false
    },
    {
        "id": 18,
        "label": "FIAT",
        "country": "Italy",
        "top": false
    },
    {
        "id": 330,
        "label": "VENTURI",
        "country": "France",
        "top": false
    },
    {
        "id": 126,
        "label": "FERRARI",
        "country": "Italy",
        "top": false
    },
    {
        "id": 137,
        "label": "MASERATI",
        "country": "Italy",
        "top": false
    },
    {
        "id": 22,
        "label": "ALFA ROMEO",
        "country": "Italy",
        "top": false
    },
    {
        "id": 32,
        "label": "VOLVO",
        "country": "Sweden",
        "top": true
    },
    {
        "id": 150,
        "label": "SAAB",
        "country": "Sweden",
        "top": false
    },
    {
        "id": 332,
        "label": "DONKERVOORT",
        "country": "Germany",
        "top": false
    },
    {
        "id": 241,
        "label": "KIA",
        "country": "Korea",
        "top": false
    },
    {
        "id": 142,
        "label": "MORGAN",
        "country": "Great Britain",
        "top": false
    },
    {
        "id": 123,
        "label": "DAEWOO",
        "country": "Korea",
        "top": false
    },
    {
        "id": 147,
        "label": "PONTIAC",
        "country": "USA",
        "top": false
    },
    {
        "id": 118,
        "label": "BUICK",
        "country": "USA",
        "top": false
    },
    {
        "id": 36,
        "label": "MERCURY",
        "country": "USA",
        "top": false
    },
    {
        "id": 134,
        "label": "LAMBORGHINI",
        "country": "Italy",
        "top": false
    },
    {
        "id": 135,
        "label": "LANCIA",
        "country": "Italy",
        "top": false
    },
    {
        "id": 136,
        "label": "LOTUS",
        "country": "Great Britain",
        "top": false
    },
    {
        "id": 138,
        "label": "MCC SMART",
        "country": "Germany",
        "top": false
    },
    {
        "id": 130,
        "label": "HYUNDAI",
        "country": "Korea",
        "top": false
    },
    {
        "id": 139,
        "label": "MINI",
        "country": "Germany",
        "top": true
    },
    {
        "id": 255,
        "label": "MAYBACH",
        "country": "Germany",
        "top": false
    },
    {
        "id": 116,
        "label": "BIRKIN",
        "country": "",
        "top": false
    },
    {
        "id": 129,
        "label": "HUMMER",
        "country": "USA",
        "top": false
    },
    {
        "id": 17,
        "label": "DAIMLER",
        "country": "Great Britain",
        "top": false
    },
    {
        "id": 127,
        "label": "GM MATIZ",
        "country": "Korea",
        "top": false
    },
    {
        "id": 335,
        "label": "AUTOBIANCHI",
        "country": "Italy",
        "top": false
    },
    {
        "id": 331,
        "label": "YES",
        "country": "Germany",
        "top": false
    },
    {
        "id": 23,
        "label": "LEXUS",
        "country": "Japan",
        "top": true
    },
    {
        "id": 124,
        "label": "DODGE",
        "country": "USA",
        "top": false
    },
    {
        "id": 334,
        "label": "ABARTH",
        "country": "Italy",
        "top": false
    },
    {
        "id": 333,
        "label": "CT T",
        "country": "Korea",
        "top": false
    }
];



// WEBPACK FOOTER //
// ./src/api/apiAuctions.js